import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const Breadcrumbs = ({ items }) => {
  return (
    <nav aria-label="Breadcrumb" className="bg-nubia-gray-light/50 border-b border-nubia-gray-light">
      <div className="container mx-auto px-4 py-3">
        <ol className="flex items-center gap-2 text-sm flex-wrap">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            
            return (
              <li key={index} className="flex items-center gap-2">
                {!isLast ? (
                  <>
                    <Link
                      to={item.href}
                      className="text-nubia-green-support hover:text-nubia-gold-primary transition-colors font-medium"
                    >
                      {item.label}
                    </Link>
                    <ChevronRight className="w-4 h-4 text-nubia-text-dark/40" />
                  </>
                ) : (
                  <span className="text-nubia-text-dark/70 font-medium truncate max-w-xs sm:max-w-md md:max-w-lg">
                    {item.label}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumbs;
